import Vue from "vue";
import VueI18n from "vue-i18n";
import VueCookies from "vue-cookies";
import en from "./../assets/langs/en.json";
import th from "./../assets/langs/th.json";

const messages = {
  en: en,
  th: th
};

Vue.use(VueI18n);
Vue.use(VueCookies);

let language = VueCookies.get("language") || "en";

export const i18n = new VueI18n({
  locale: language, // set locale
  fallbackLocale: language,
  messages // set locale messages
});
